import React, { useMemo, useState } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { Flex } from '@withjoy/joykit';
import { AccommodationsList } from '../AccommodationsList';
import { Tabs } from '@shared/components/Tabs/Tabs';
import { VacationRentals } from '../VacationRentals';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

type TabType = 'hotels' | 'vacationRentals';

export const TabMenu: React.FC = () => {
  const [isAccommodationsVacationRentalsEnabled] = useIsFeatureEnabled('accommodationsVacationRentals');
  const { tq } = useTranslation('accommodationsAdmin');
  const [activeTab, setActiveTab] = useState<TabType>('hotels');

  const tabItems = useMemo(
    () => [
      {
        label: 'hotels',
        value: tq`Hotels`,
        isActive: activeTab === 'hotels',
        onClick: () => setActiveTab('hotels'),
      },
      {
        label: 'vacationRentals',
        value: tq`Stay Areas`,
        isActive: activeTab === 'vacationRentals',
        onClick: () => setActiveTab('vacationRentals'),
      },
    ],
    [activeTab, tq],
  );

  if (!isAccommodationsVacationRentalsEnabled) {
    return <AccommodationsList />;
  }

  return (
    <Flex
      flexDirection="column"
      gap={4}
      marginTop={3}
    >
      <Flex justifyContent="center">
        <Tabs
          items={tabItems}
          tabTextProps={{
            paddingX: pxToRem(10),
            whiteSpace: 'nowrap',
          }}
        />
      </Flex>

      {activeTab === 'hotels' && <AccommodationsList />}
      {activeTab === 'vacationRentals' && <VacationRentals />}
    </Flex>
  );
};
